import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CookieNotice from "./CookieNotice";
import ScrollProgress from "./ScrollProgress";
import { useI18n } from "@/i18n";

/**
 * 對外頁面的外框（首頁、案件、人才、價格…）。
 * 行動辦公室不走這裡 —— 它有自己的 DashboardLayout。
 */
export default function Shell() {
  const { t } = useI18n();

  return (
    <div className="flex min-h-screen flex-col bg-page">
      <ScrollProgress />
      <Header />
      {/* 跳過導覽的無障礙連結，鍵盤 Tab 第一下就會看到 */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-brand-800 focus:px-4 focus:py-2 focus:text-white"
      >
        {t("a11y.skipToContent")}
      </a>
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />

      {/* 告知而非同意徵詢 —— 本站只有嚴格必要的 cookie，見 CookieNotice 的說明 */}
      <CookieNotice />
    </div>
  );
}
